module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paco-status"
  }, [_c('div', {
    staticClass: "paco-status__card"
  }, [(_vm.status === 'polling') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__spinner"
  }, [_c('svg', {
    staticClass: "paco-status__spinner-svg",
    attrs: {
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "20",
      "fill": "none",
      "stroke-width": "4"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title"
  }, [_vm._v("กำลังตรวจสอบการชำระเงิน")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.status === 'failed') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__icon",
    class: _vm.isCancelled ? 'paco-status__icon--warning' : 'paco-status__icon--error'
  }, [(!_vm.isCancelled) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isCancelled) ? _c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "15",
      "y1": "9",
      "x2": "9",
      "y2": "15"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "9",
      "y1": "9",
      "x2": "15",
      "y2": "15"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title",
    class: _vm.isCancelled ? 'paco-status__title--warning' : 'paco-status__title--error'
  }, [_vm._v(_vm._s(_vm.isCancelled ? 'การชำระเงินถูกยกเลิก' : 'การชำระเงินไม่สำเร็จ'))]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__subtitle"
  }, [_vm._v(_vm._s(_vm.failureMessage))]), _vm._v(" "), (_vm.failureInfo && _vm.failureInfo.respCode) ? _c('p', {
    staticClass: "paco-status__ref"
  }, [_vm._v("รหัสอ้างอิง: " + _vm._s(_vm.failureInfo.respCode)), (_vm.failureInfo.respDesc) ? _c('br') : _vm._e(), _vm._v(_vm._s(_vm.failureInfo.respDesc))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "paco-status__btn",
    on: {
      "click": _vm.goToCheckout
    }
  }, [_vm._v("ลองชำระเงินอีกครั้ง")])]) : _vm._e(), _vm._v(" "), (_vm.status === 'timeout') ? _c('div', {
    staticClass: "paco-status__state"
  }, [_c('div', {
    staticClass: "paco-status__icon paco-status__icon--warning"
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "8",
      "x2": "12",
      "y2": "12"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "16",
      "x2": "12.01",
      "y2": "16"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "paco-status__title paco-status__title--warning"
  }, [_vm._v("ไม่สามารถยืนยันการชำระเงินได้")]), _vm._v(" "), _c('p', {
    staticClass: "paco-status__subtitle"
  }, [_vm._v("กรุณาตรวจสอบอีเมลของคุณ หรือติดต่อเราเพื่อยืนยันสถานะการบริจาค")]), _vm._v(" "), _c('button', {
    staticClass: "paco-status__btn",
    on: {
      "click": _vm.goToHome
    }
  }, [_vm._v("กลับไปยังหน้าหลัก")])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "paco-status__progress"
  }, [_c('div', {
    staticClass: "paco-status__progress-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51e09e38","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PacoStatus.vue
// module id = 719
// module chunks = 1